import { render, staticRenderFns } from "./ProductItemone.vue?vue&type=template&id=91762c90&scoped=true"
import script from "./ProductItemone.vue?vue&type=script&lang=js"
export * from "./ProductItemone.vue?vue&type=script&lang=js"
import style0 from "./ProductItemone.vue?vue&type=style&index=0&id=91762c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91762c90",
  null
  
)

export default component.exports